import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Heading } from '@grandvisionhq/elements';

const StoreTileHeading = (_param)=> {
    var { children , className  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "children",
        "className"
    ]);
    return React.createElement(Heading, swcHelpers.extends({}, rest, {
        className: classnames('store-tile__typography-heading', className)
    }), children);
};

export { StoreTileHeading as default };
//# sourceMappingURL=StoreTileHeading.js.map
